import Velocity from "velocity-animate";
import UserService from "@/services/UserService";
import { mapGetters, mapActions } from "vuex";

export default {
    name: "SynonymThumbVote",
    props: {
        item: {
            type: Object,
            required: true
        },
        thumbUp: {
            type: Boolean,
            required: true
        },
        thumbDown: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            isUpvoted: this.thumbUp,
            isDownvoted: this.thumbDown,
            isUpvoteProcessing: false,
            isDownvoteProcessing: false
        };
    },
    computed: {
        ...mapGetters("Login", ["user"]),
        getThumbsUpAltText() {
            return this.isUpvoted
                ? this.$t("thumbUpAltTextSelected")
                : this.$t("thumbUpAltTextNonSelected");
        },
        getThumbsDownAltText() {
            return this.isDownvoted
                ? this.$t("thumbDownAltTextSelected")
                : this.$t("thumbDownAltTextNonSelected");
        },
        upvotes() {
            return this.transformVoteAmount(this.item.upvotes);
        },
        downvotes() {
            return this.transformVoteAmount(this.item.downvotes);
        }
    },
    watch: {
        thumbUp() {
            this.isUpvoted = this.thumbUp;
        },
        thumbDown() {
            this.isDownvoted = this.thumbDown;
        },
        upvotes() {
            this.isUpvoteProcessing = false;
        },
        downvotes() {
            this.isDownvoteProcessing = false;
        }
    },
    methods: {
        ...mapActions("Login", ["updateUserLikedWords"]),
        vote(action) {
            let userAction = "";
            switch (action) {
                case "upvote":
                    if (this.isDownvoteProcessing) return;
                    userAction = this.isUpvoted
                        ? "removeUpvote"
                        : this.isDownvoted
                        ? "changeDownvoteToUpvote"
                        : "upvote";
                    this.isUpvoteProcessing = true;
                    this.$ga.event({
                        eventCategory: "Synonym Thumb Up",
                        eventAction: userAction
                    });
                    break;
                case "downvote":
                    if (this.isUpvoteProcessing) return;
                    userAction = this.isDownvoted
                        ? "removeDownvote"
                        : this.isUpvoted
                        ? "changeUpvoteToDownvote"
                        : "downvote";
                    this.isDownvoteProcessing = true;
                    this.$ga.event({
                        eventCategory: "Synonym Thumb Down",
                        eventAction: userAction
                    });
                    break;
            }

            const idToken = this.user.loggedIn ? this.user.data.idToken : "";
            const actions = {
                action: userAction,
                relationIds: [this.item.word.relationId]
            };

            UserService.voteSynonym(idToken, actions)
                .then(response => {
                    const { status } = response.data;
                    if (status === "OK") this.toggleVoteButtonState(actions);
                })
                .catch(e => {
                    console.error("error", e);
                });
        },
        toggleVoteButtonState(actions) {
            switch (actions.action) {
                case "upvote":
                    this.isUpvoted = !this.isUpvoted;
                    this.isUpvoted ? this.item.upvotes++ : this.item.upvotes--;
                    break;
                case "downvote":
                    this.isDownvoted = !this.isDownvoted;
                    this.isDownvoted ? this.item.downvotes++ : this.item.downvotes--;
                    break;
                case "removeUpvote":
                    this.isUpvoted = false;
                    this.item.upvotes--;
                    break;
                case "removeDownvote":
                    this.isDownvoted = false;
                    this.item.downvotes--;
                    break;
                case "changeUpvoteToDownvote":
                    this.isUpvoted = false;
                    this.isDownvoted = true;
                    this.item.upvotes--;
                    this.item.downvotes++;
                    break;
                case "changeDownvoteToUpvote":
                    this.isUpvoted = true;
                    this.isDownvoted = false;
                    this.item.upvotes++;
                    this.item.downvotes--;
                    break;
            }
            this.isUpvoteProcessing = false;
            this.isDownvoteProcessing = false;
            this.updateUserLikedWords(actions);
        },
        transformVoteAmount(val) {
            return val >= 1000 ? (val / 1000).toFixed() + "K" : val;
        },

        // Thumb icon animation
        thumbBeforeEnter(el) {
            el.style.transform = "scale(0)";
        },
        thumbEnter(el, done) {
            Velocity(el, { scale: "0" }, { duration: 10, delay: 170 });
            Velocity(el, { scale: "1.2" }, { duration: 250 });
            Velocity(el, { scale: "1" }, { duration: 90 }, { complete: done });
        },
        thumbBeforeLeave(el) {
            el.style.transform = "scale(1)";
        },
        thumbLeave(el, done) {
            Velocity(el, { scale: 1.2 }, { duration: 100 });
            Velocity(el, { scale: 0 }, { duration: 150 }, { complete: done });
        },

        // Thumb background animation
        thumbBgInit(el) {
            el.style.transform = "scale(0)";
        },
        thumbFilledBgEnter(el, done) {
            Velocity(el, { opacity: 0.8, scale: 0 }, { duration: 5 });
            Velocity(el, { opacity: 0.3, scale: 1 }, { duration: 350 });
            Velocity(el, { opacity: 0, scale: 0 }, { duration: 1, complete: done });
        },
        thumbStrokeBgEnter(el, done) {
            Velocity(el, { opacity: 0.8, scale: 0 }, { delay: 180, duration: 5 });
            Velocity(el, { opacity: 0.3, scale: 1 }, { duration: 350 });
            Velocity(el, { opacity: 0, scale: 0 }, { duration: 1, complete: done });
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/Synonym/SynonymThumbsVote/SynonymThumbsVote.js